// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button-banner-remove[data-v-bcf10cbe] {\n  height: 44px !important;\n}\n.vx-card .vx-card__collapsible-content img[data-v-bcf10cbe] {\n  display: inline;\n}\n[dir] .card-image-container[data-v-bcf10cbe] {\n  padding-top: 40%;\n}\n.ellipsis[data-v-bcf10cbe]{\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n", ""]);
// Exports
module.exports = exports;
